/**
 * The read-only demo artist (LaziiBee). music24-api adds it to the end of every workspace's
 * artist list with `isDemo: true`. It never counts towards the plan's artists, and the app never
 * selects it by itself. design: music24-demo-artist a1.
 */

/**
 * The demo artist's account id. The tRPC client reads only the active id from the store, so it
 * needs the number itself. Keep it in step with `DEMO_ACCOUNT_ID` in
 * music24-api/src/app/components/DemoArtist/demoArtist.ts.
 */
export const DEMO_ACCOUNT_ID = 2_000_000_000;

/** True for the demo artist's account id. */
export function isDemoAccountId(accountId: number | null | undefined): boolean {
  return accountId === DEMO_ACCOUNT_ID;
}

interface MaybeDemoAccount {
  id: number;
  isDemo?: boolean;
}

export function isDemoAccount(account: MaybeDemoAccount | null | undefined): boolean {
  return account?.isDemo === true;
}

/** The artists of the workspace without the demo artist. */
export function withoutDemoAccounts<T extends MaybeDemoAccount>(accounts: readonly T[]): T[] {
  return accounts.filter((account) => !isDemoAccount(account));
}

/** The number of the user's own artists (the demo left out). `undefined` while the list loads. */
export function countOwnArtists(accounts: readonly MaybeDemoAccount[] | undefined): number | undefined {
  if (accounts === undefined) {
    return undefined;
  }
  return withoutDemoAccounts(accounts).length;
}

/** The ids of the demo artists in the list (zero or one). */
export function demoAccountIds(accounts: readonly MaybeDemoAccount[]): number[] {
  return accounts.filter(isDemoAccount).map((account) => account.id);
}

/** The first artist that is not the demo, or null when the user has no artist of their own. */
export function firstOwnAccountId(accounts: readonly MaybeDemoAccount[] | undefined): number | null {
  return accounts?.find((account) => !isDemoAccount(account))?.id ?? null;
}
